import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

// Enforces the same roles/adminOrgOnly policy Sidebar.js already used to
// decide whether to *show* a nav link - but that was the only enforcement
// that existed. Any logged-in user of any role/org could still reach the
// page underneath just by typing its URL (e.g. a doctor navigating
// directly to /admin/organizations), since AppRoutes.js rendered every
// route unconditionally. This wraps the specific routes that have a
// declared policy (see config/navMenuItems.js, the single shared source
// for both) and redirects instead of rendering when it isn't satisfied.
export default function ProtectedRoute({ roles, adminOrgOnly, hideForAdminOrg, children }) {
  const storedUser = localStorage.getItem("auth");
  if (!storedUser) {
    return <Navigate to="/" replace />;
  }

  let role = null;
  let orgUid = null;
  try {
    const authData = JSON.parse(storedUser);
    if (authData.token) {
      const decoded = jwtDecode(authData.token);
      role = (decoded.sub?.role || authData.role || "").toLowerCase();
      orgUid = decoded.sub?.org_uid || null;
    }
  } catch (err) {
    return <Navigate to="/" replace />;
  }

  if (!role || (roles && !roles.includes(role))) {
    return <Navigate to="/dashboard" replace />;
  }

  if (adminOrgOnly) {
    const adminOrgId = process.env.REACT_APP_ADMIN_ORG_ID;
    if (!adminOrgId || orgUid !== adminOrgId) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Practice pages the platform org itself must never use (see navMenuItems.js).
  if (hideForAdminOrg) {
    const adminOrgId = process.env.REACT_APP_ADMIN_ORG_ID;
    if (adminOrgId && orgUid === adminOrgId) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
